import { cx } from '@/styled-system/css';
import { starButton, starFilled, starGroup } from './starRating.styles';

type StarRatingProps = {
  value: number;
  onChange: (rating: number) => void;
  disabled?: boolean;
};

const STAR_COUNT = 5;

export default function StarRating({ value, onChange, disabled = false }: StarRatingProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (disabled) return;

    if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
      if (value < STAR_COUNT) {
        e.preventDefault();
        onChange(value + 1);
      }
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
      if (value > 1) {
        e.preventDefault();
        onChange(value - 1);
      }
    }
  };

  return (
    <div role="radiogroup" aria-label="Rating" className={starGroup} tabIndex={0} onKeyDown={handleKeyDown}>
      {Array.from({ length: STAR_COUNT }, (_, i) => {
        const starValue = i + 1;
        const isFilled = starValue <= value;
        const label = starValue === 1 ? '1 star' : `${starValue} stars`;

        return (
          <button
            key={starValue}
            type="button"
            role="radio"
            aria-checked={isFilled}
            aria-label={label}
            className={cx(starButton, isFilled && starFilled)}
            disabled={disabled}
            onClick={() => {
              if (!disabled) {
                onChange(starValue);
              }
            }}
          >
            {isFilled ? '\u2605' : '\u2606'}
          </button>
        );
      })}
    </div>
  );
}
